import React from "react";
import axios from 'axios';

var UserStateContext = React.createContext();
var UserDispatchContext = React.createContext();

function userReducer(state, action) {
  switch (action.type) {
    case "LOGIN_SUCCESS":
      return { ...state, isAuthenticated: true };
    // case "LOGIN_FAILURE":
    //   return { ...state, isAuthenticated: false };
    case "SIGN_OUT_SUCCESS":
      return { ...state, isAuthenticated: false };
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function UserProvider({ children }) {
  var [state, dispatch] = React.useReducer(userReducer, {
    isAuthenticated: !!localStorage.getItem("id_token"),
  });

  return (
    <UserStateContext.Provider value={state}>
      <UserDispatchContext.Provider value={dispatch}>
        {children}
      </UserDispatchContext.Provider>
    </UserStateContext.Provider>
  );
}

function useUserState() {
  var context = React.useContext(UserStateContext);
  if (context === undefined) {
    throw new Error("useUserState must be used within a UserProvider");
  }
  return context;
}

function useUserDispatch() {
  var context = React.useContext(UserDispatchContext);
  if (context === undefined) {
    throw new Error("useUserDispatch must be used within a UserProvider");
  }
  return context;
}

export { UserProvider, useUserState, useUserDispatch, loginUser, EnterpriseLogin, signOut };

// ###########################################################

function EnterpriseLogin(org, username, token, setIsLoading, setError, dispatch){ 
  setError(false);
  setIsLoading(true);
  axios.get(`${org}/users/${username}`)
      .then(res => {
        localStorage.setItem('first_name', res.data.user.first_name)
        localStorage.setItem('last_name', res.data.user.last_name)
        localStorage.setItem('id_token', token)
        if(res.data){
          console.log('navigate function')
          setError(null)
          setIsLoading(false)
          dispatch({ type: 'LOGIN_SUCCESS' })
        }        
      }).catch(err => {
        //enqueueSnackbar('Cannot redirect to site', { variant: 'warning' });
      });

}
function loginUser(dispatch, login, password, history, setIsLoading, setError) {
  setError(false);
  setIsLoading(true);

  if (!!login && !!password) {

    const user = {
      username: login,
      password: password
    };

    axios.post(`/login`, user)
      .then(res => {
        // console.log(res);
        // console.log(res.data.token);
        localStorage.setItem('id_token', res.data.token)
        localStorage.setItem('organization', res.data.user.organization)
        localStorage.setItem('first_name', res.data.user.first_name)
        localStorage.setItem('last_name', res.data.user.last_name)
        localStorage.setItem('email', res.data.user.email)

        setError(null)
        setIsLoading(false)
        axios.defaults.headers.common["Authorization"] = "JWT " + res.data.token;
        dispatch({ type: 'LOGIN_SUCCESS' })
      }).catch(err=>{
        setError(true);
        setIsLoading(false);
      });

    // setTimeout(() => {
    //   localStorage.setItem('id_token', 1)
    //   setError(null)
    //   setIsLoading(false)
    //   dispatch({ type: 'LOGIN_SUCCESS' })

    //   history.push('/app/dashboard')
    // }, 2000);
  } else {
    dispatch({ type: "LOGIN_FAILURE" });
    setError(true);
    setIsLoading(false);
  }
}

function signOut(dispatch, history) {
  localStorage.removeItem("id_token");
  localStorage.removeItem("organization");
  localStorage.removeItem("first_name");
  localStorage.removeItem("last_name");
  localStorage.removeItem("email");
  axios.defaults.headers.common["Authorization"] = "";
  dispatch({ type: "SIGN_OUT_SUCCESS" });
  history.push("/login");
}
